import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * A simple loading screen component with spinner and message
 * 
 * @param {Object} props
 * @param {string} props.message - Optional message to display below the spinner
 * @param {string} props.subMessage - Optional secondary message
 */
const LoadingScreen = ({ message, subMessage }) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-white">
      <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin mb-4"></div>
      
      {message && (
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          {message}
        </h2>
      )}
      
      {subMessage && (
        <p className="text-gray-500">
          {subMessage}
        </p>
      )}
      
      {!message && !subMessage && (
        <>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            {t('loading')}
          </h2>
          <p className="text-gray-500">
            {t('pleaseWait')}
          </p>
        </>
      )}
    </div>
  );
};

export default LoadingScreen; 